import { render, staticRenderFns } from "./trainRecord.vue?vue&type=template&id=665f110d&scoped=true&"
import script from "./trainRecord.vue?vue&type=script&lang=js&"
export * from "./trainRecord.vue?vue&type=script&lang=js&"
import style0 from "./trainRecord.vue?vue&type=style&index=0&id=665f110d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f110d",
  null
  
)

export default component.exports